<template>
  <div v-if="update.id" class="update">
    <font-awesome-icon
      v-if="ownedByMe"
      icon="times"
      size="1x"
      class="delete-icon"
      @click="deleteUpdate"
    />
    <div class="update__title">{{ update.title }}</div>
    <div v-if="update.datetimeCreated" class="update__small-description">
      {{ update.datetimeCreated | momentDateTime }}
    </div>
    <div class="row">
      <img
        v-for="projectPhoto in update.photos"
        :key="projectPhoto.id"
        :src="projectPhoto.photo"
        alt="Project Photo"
        class="photo"
      />
    </div>
    <div v-if="update.description" class="update__description">{{ update.description }}</div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UpdateCard',
  props: {
    update: {
      type: Object,
      default: null,
    },
    ownedByMe: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: null,
    },
  },
  created() {
    this.update.datetimeCreated = this.dateFormatForUI(this.update.datetimeCreated)
  },
  methods: {
    onClickDonate() {
      this.$router.push({
        name: 'GoalDonation',
        params: { projectId: this.project.id, goalId: this.goal.id, isCurrent: true },
      })
    },
    dateFormatForUI(date) {
      //accounting for error "Invalid date" if endDate is unable to be coerced into specified format
      //will reset datetimeCreated to null if error occurs
      const dateFormatForUI = moment(date).format('YYYY-MM-DDTHH:mm')
      if (!dateFormatForUI || dateFormatForUI === 'Invalid date') {
        return null
      } else {
        return dateFormatForUI
      }
    },
    deleteUpdate() {
      this.$emit('delete-update', this.update)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/layout';

.update {
  width: 100%;
  padding: 1rem 1rem 1.5rem 1rem;

  &__title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__small-description {
    text-align: left;
    font-size: 12px;
    line-height: normal;
    color: $gray;
    margin-bottom: 8px;
  }

  &__description {
    text-align: left;
    font-size: 14px;
    line-height: 1.1rem;
    padding: 2px 20px 16px 0;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
}

.delete-icon {
  float: right;
  margin-right: 4px;
  cursor: pointer;
}
</style>
